export default "__VITE_ASSET__B2f__Io5__"